import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, memo } from 'react';
import { ArrowRightIcon } from '@deliveryhero/armor-icons';
import { useDatePickerTopBarClassNames } from './hooks/useDatePickerTopBarClassNames';
import { useDatePickerTopBar } from './hooks/useDatePickerTopBar';
import { DatePickerTopBarMonthNavigation, DatePickerTopBarMonthNavigationButtonBackward, DatePickerTopBarMonthNavigationButtonForward, DatePickerTopBarMonthYearSelectorToggle, DatePickerTopBarMonthYearSelectorToggleArrow, DatePickerTopBarRoot } from './style';
import { DATE_PICKER_TOP_BAR_CLASS_PREFIX } from './constants';
/**
 * @internal
 */
export var DatePickerTopBar = memo(forwardRef(function DatePickerTopBar(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerTopBarClassNames(DATE_PICKER_TOP_BAR_CLASS_PREFIX, className);
  var _useDatePickerTopBar = useDatePickerTopBar(props, ref),
    rootProps = _useDatePickerTopBar.rootProps,
    monthYearSelectorToggleProps = _useDatePickerTopBar.monthYearSelectorToggleProps,
    monthYearSelectorToggleArrowProps = _useDatePickerTopBar.monthYearSelectorToggleArrowProps,
    monthNavigationButtonBackwardProps = _useDatePickerTopBar.monthNavigationButtonBackwardProps,
    monthNavigationButtonForwardProps = _useDatePickerTopBar.monthNavigationButtonForwardProps,
    year = _useDatePickerTopBar.year,
    monthName = _useDatePickerTopBar.monthName;
  return React.createElement(DatePickerTopBarRoot, _objectSpread(_objectSpread({}, rootProps), {}, {
    className: classNameComponents.Root
  }), React.createElement(DatePickerTopBarMonthYearSelectorToggle, _objectSpread(_objectSpread({}, monthYearSelectorToggleProps), {}, {
    className: classNameComponents.MonthYearSelectorToggle
  }), monthName, " ", year, React.createElement(DatePickerTopBarMonthYearSelectorToggleArrow, _objectSpread(_objectSpread({}, monthYearSelectorToggleArrowProps), {}, {
    small: true,
    marginLeft: 1,
    className: classNameComponents.MonthYearSelectorToggleArrow
  }))), React.createElement(DatePickerTopBarMonthNavigation, {
    className: classNameComponents.MonthNavigation
  }, React.createElement(DatePickerTopBarMonthNavigationButtonBackward, _objectSpread(_objectSpread({}, monthNavigationButtonBackwardProps), {}, {
    className: classNameComponents.MonthNavigationButtonBackward,
    type: "button"
  }), React.createElement(ArrowRightIcon, {
    small: true,
    className: classNameComponents.MonthNavigationButtonArrow
  })), React.createElement(DatePickerTopBarMonthNavigationButtonForward, _objectSpread(_objectSpread({}, monthNavigationButtonForwardProps), {}, {
    className: classNameComponents.MonthNavigationButtonForward,
    type: "button"
  }), React.createElement(ArrowRightIcon, {
    small: true,
    className: classNameComponents.MonthNavigationButtonArrow
  }))));
}));
DatePickerTopBar.displayName = DATE_PICKER_TOP_BAR_CLASS_PREFIX;